import {State, STEP} from "./solutionGuideStore";
import type {GetterTree} from "vuex";
import type {SolutionGuide} from "../../../../../_types/solutionguide";
import type {Productfinder} from "../../../../../_types/productfinder";

export function isProductAvailable(state: State, product: SolutionGuide.DekorativePlatte): boolean {
    return state.properties.length === 0 || state.properties.findIndex(stateId => !product.propertyIds.includes(stateId)) === -1
}

export const individualPropertyId = 'EV213430'

export function isIndividualProduct(product: SolutionGuide.DekorativePlatte): boolean {
    return product.propertyIds.includes(individualPropertyId)
}

export function isIndividualSelected(state: State): boolean {
    return state.properties.indexOf(individualPropertyId) !== -1
}

export default <GetterTree<State, unknown>>{
    isActiveStep: state => {
        return (step: STEP) => step === state.activeStep
    },
    getProduct: state => {
        return (id: string) => {
            return state.segment?.productMap[id]
        }
    },
    getProperty: state => {
        return (id: string) => {
            return state.segment?.propertyMap[id]
        }
    },
    isPropertySelected: state => {
        return (id: string) => {
            return state.properties.indexOf(id) >= 0
        }
    },
    isPropertyDisabled: (state, getters) => {
        return (id: string) => {
            // selected properties => state.properties
            // Disabled, wenn es kein Produkt gibt, dass alle selected Properties enthält und zusätzlich die id

            // Kann natürlich nie disabled sein, wenn sie ausgewähl ist :)
            if (state.properties.includes(id)) {
                return false
            }

            if (!state.component) {
                return false // aka: This should never happen :o
            }

            return state.component.productIds.findIndex(productId => {
                // Check if product contains all selected properties => product is still available
                const product = getters.getProduct(productId)
                return getters.isProductAvailable(product)
                // Additionally check if product contains the property id
                    && product.propertyIds.includes(id)
            }) < 0
        }
    },
    isProductAvailable: state => {
        return (product: SolutionGuide.DekorativePlatte) => isProductAvailable(state, product)
    },
    isPreviousStep: state => {
        return (step: STEP) => {
            const values = Object.values(STEP)
            return values.indexOf(step) >= 0 && values.indexOf(step) < values.indexOf(state.activeStep)
        }
    },
    isMobile: state => state.activeBreakpoint === "xs" || state.activeBreakpoint === "sm",
    sortAndResolvePropertyIds: (state, getters) => (propertyIds: string[]): SolutionGuide.Property[] => {
        const properties = propertyIds.map((id: string) => getters.getProperty(id))
        return properties.sort((a: SolutionGuide.Property, b: SolutionGuide.Property) => a.name.localeCompare(b.name))
    },
    selectedDecor: (state: State) => {
        if (state.component && state.result) {
            return state.selectedDecors[state.component.name + '#' + state.result.pim_id]
        } else {
            return state.decor !== null
        }
    },
    getSelectedDecor: state => (key: string): Productfinder.Product | undefined => {
        return state.selectedDecors[key]
    },
    getPossibleResults: state => {
        if (state.segment && state.application && state.component) {
            return state.component.productIds.map(
                productId => state.segment?.productMap[productId]).filter(
                product => {
                    return product && isProductAvailable(state, product)
                }) || []
        }
    }
}
